import { IXepTkbChuanBiActionTypes } from "../../action-types/ke-hoach/IXepTkbChuanBiActions";
import { IXepTkbChuanBiReducer } from "../../reducer-model/ke-hoach/IXepTkbChuanBiReducer";

const iniState: IXepTkbChuanBiReducer = {
  isCreating: false,
};

export const xepTkbChuanBiReducer = (
  state: IXepTkbChuanBiReducer = iniState,
  action: IXepTkbChuanBiActionTypes
): IXepTkbChuanBiReducer => {
  switch (action.type) {
    case "XEP_TKB_CHUAN_BI_TAO_LAI_THEO_MON_START":
    case "XEP_TKB_CHUAN_BI_CAP_NHAT_SU_KIEN_START":
      return { ...state, isCreating: true };
    case "XEP_TKB_CHUAN_BI_TAO_LAI_THEO_MON_SUCCESS":
    case "XEP_TKB_CHUAN_BI_TAO_LAI_THEO_MON_ERROR":
    case "XEP_TKB_CHUAN_BI_CAP_NHAT_SU_KIEN_SUCCESS":
    case "XEP_TKB_CHUAN_BI_CAP_NHAT_SU_KIEN_ERROR":
      return { ...state, isCreating: false };
    default:
      return state;
  }
};
